"use client";

import { useNavigation } from "@/app/hooks/useNavigation"
import { TCustomButtonProps } from "../../types/types";
import OneDirectionArrow from "./icons/OneDirectionArrow";

const CustomButton: React.FC<TCustomButtonProps> = ({
  text,
  url,
  icon,
  type,
  action,
  customClass,
  disabled,
  blank,
  style,
  hasIcon,
  iconBefore,
  ref,
  iconCustomClass
}) => {
  const router = useNavigation();

  const styles = {
    blue: `bg-oBlue-100 border-oBlue-100 hover:bg-oBlue-80 hover:border-oBlue-80 text-white    ${disabled ? "opacity-70 cursor-not-allowed pointer-events-none" : ""}`,
    grey: `bg-oBlack-10 border-transparent hover:bg-oBlack-20 hover:border-transparent text-black  ${disabled ? "opacity-70 cursor-not-allowed bg-oBlue-80 pointer-events-none" : ""}`,
    transparent:
      `hover:bg-oWhite-10 text-white  border-white ${disabled ? "opacity-70 cursor-not-allowed bg-oWhite-10 pointer-events-none" : ""}`,
    white:
      `bg-white border-white hover:bg-oWhite-80 hover:border-oWhite-80 text-black    ${disabled ? "opacity-70 cursor-not-allowed !bg-oWhite-80 pointer-events-none" : ""}`,
    masterPlanDark:
      `bg-oBlack-20 border-oBlack-20 hover:bg-oBlack-30 hover:border-oBlack-30 text-white f  linear-gradient-border ${disabled ? "opacity-70 cursor-not-allowed bg-oBlack-30 pointer-events-none" : ""}`,
  };

  return (
    <button
      ref={ref}
      className={`custom-button flex items-center justify-center uppercase p-3 ps-5 gap-2 font-minerva-regular btn-border-radius border border-solid  ${hasIcon ? "p-3 ps-5" : "px-5 py-2"
        } ${styles[style || "blue"]} ${customClass || ""}`}
      onClick={(e) => {
        e.stopPropagation();
        if (action && !disabled) action();
        if (url && !disabled) {
          if (blank) {
            window.open(url, "_blank")
          } else {
            router.push(url);
          }
        }
      }
      }
      type={type}
      disabled={disabled}
    >
      {iconBefore && <span className="icon || w-6">{iconBefore}</span>}
      <div className="flex items-center">
        <span className="font-minerva-bold text-labelM whitespace-nowrap small-mobile:text-labelS">{text}</span>
      </div>
      {hasIcon && (
        <span className={`icon || w-6 ${iconCustomClass}`}>
          {icon ? (
            icon
          ) : (
            <OneDirectionArrow
              color={` ${style === "white" || style === "grey" ? "black" : "white"
                }`}
            />
          )}
        </span>
      )}
    </button>
  );
};

export default CustomButton;
